// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"8fe8d64c","453":"3b554986"}[chunkId] + ".chunk.js";
};